import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'zone.js';

// ng2-pdf-viewer (pdfjs-dist) defaults to loading its worker script from a
// public CDN (cdn.jsdelivr.net), which is not whitelisted by the app's
// Content-Security-Policy (script-src 'self' ...) and fails silently.
// Point it at the copy of the worker bundled with the app instead. pdf.js
// loads the worker as an ES module, which requires an absolute URL (a bare
// relative path like 'assets/pdf.worker.min.mjs' fails module-specifier
// resolution), so resolve it against the document's <base href>.
(window as any).pdfWorkerSrc = new URL('assets/pdf.worker.min.mjs', document.baseURI).href;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
